/* eslint-disable radix */
/* eslint-disable prefer-const */
import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

import { RoutesMapping } from '../../core/route/routesMapping';
import { GeneralContext } from '../../core/app-context/GeneralContext';
import { ConfigCard } from '../../shared/components/ConfigCard';
import { NormalText, Spacer } from './styles';
import ItemRow from './components/ItemRow';
import { CustomTextField } from '../DevolutionPageConfig/components/CustomTextField';
import { PrivatePageStructure } from '../../shared/components/PrivatePageStructure';
import useGetEmailsPreferences from './hooks/useGetEmailsPreferences';
import usePageStore from './store/pageStore';
import Services from './services';
import { storeKeyNameFromField } from '@apollo/client/utilities';

export default function Emails() {
  const navigate = useNavigate();
  const {
    store,
    setSideMenu,
    setIdMenuSelected,
    setInfoMessage,
    setErrorMessage,
    setSuccessMessage,
  } = useContext(GeneralContext);

  useEffect(() => {
    setSideMenu('reversa');
    setIdMenuSelected('emails');
  }, [setSideMenu, setIdMenuSelected]);

  useGetEmailsPreferences();

  const emailsPreferences = usePageStore((state) => state.emailsPreferences);
  const setEmailsPreferences = usePageStore(
    (state) => state.setEmailsPreferences,
  );
  const setSenderName = usePageStore((state) => state.setSenderName);
  const loadingEmailsPreferences = usePageStore(
    (state) => state.loadingEmailsPreferences,
  );
  const fetchedData = usePageStore((state) => state.fetchedData);
  const loadingSaveChanges = usePageStore((state) => state.loadingSaveChanges);
  const setLoadingSaveChanges = usePageStore(
    (state) => state.setLoadingSaveChanges,
  );

  const handleDiscardChanges = () => {
    if (_.isEqual(emailsPreferences, fetchedData.emailsPreferences)) {
      return setInfoMessage('Não há alterações para descartar!');
    }
    setEmailsPreferences(fetchedData.emailsPreferences);
    setSuccessMessage('Alterações descartadas com sucesso!');
  };

  const handleSaveChanges = async () => {
    if (_.isEqual(emailsPreferences, fetchedData.emailsPreferences)) {
      return setInfoMessage('Não há alterações para salvar!');
    }
    try {
      setLoadingSaveChanges(true);
      const upsertResult = await Services.upsertEmailsPreferences({
        storeId: store.id,
        emailsPreferences,
      });
      if (!upsertResult) {
        setLoadingSaveChanges(false);
        return setErrorMessage('Erro ao salvar alterações');
      }
      setSuccessMessage('Alterações salvas com sucesso!');
      setEmailsPreferences(upsertResult);
      setLoadingSaveChanges(false);
    } catch (error) {
      setErrorMessage('Erro ao salvar alterações');
    }
  };

  return (
    <PrivatePageStructure
      title="Emails"
      loading={loadingEmailsPreferences}
      btn1Action={handleDiscardChanges}
      btn2Action={handleSaveChanges}
      btn2Loading={loadingSaveChanges}
    >
      <ConfigCard
        title="Email de remetente"
        subtitle="Edite as configurações de envio dos emails"
        flexDirection="column"
        alignItems="flex-start"
      >
        <NormalText>Nome</NormalText>
        <Spacer vertical height="5px" />
        <CustomTextField
          width="500px"
          value={emailsPreferences?.senderName}
          placeholder={emailsPreferences?.senderName || 'CliqueRetire Reversa'}
          setValue={(newValue) => setSenderName(newValue)}
        />
        <Spacer vertical height="5px" />
        <NormalText>Email</NormalText>
        <Spacer vertical height="5px" />
        <CustomTextField
          width="500px"
          placeholder="contato@cliqueretire.com.br"
          disabled
          value={emailsPreferences?.senderEmail}
        />
      </ConfigCard>
      <Spacer vertical />
      <ConfigCard
        title="Emais transacionais"
        subtitle="Configure individualmente cada um dos emails transacionais da devolução."
        flexDirection="column"
      >
        <ItemRow
          title="Email de seleção do método de devolução"
          onClick={() =>
            navigate(RoutesMapping.SELECT_RETURN_METHOD_EMAIL, { state: {} })
          }
        />
        <ItemRow
          title="Email pedido aprovado CliqueRetire"
          onClick={() => navigate(RoutesMapping.CLIQUERETIRE_APPROVED_EMAIL)}
        />
        <ItemRow
          title="Email pedido aprovado Correios"
          disableBottomDivider
          onClick={() => navigate(RoutesMapping.CORREIOS_APPROVED_EMAIL)}
        />
      </ConfigCard>
    </PrivatePageStructure>
  );
}
